import request from '@/utils/http'
import { SRM, PFX } from '../constant/constant.js'
// 获取资质信息树状结构（工作台端）
export const qualificationInfo = params => {
    return request({
        url: `${SRM}/supplierQualificationInfo/getTreeData/` + params,
        method: 'get',
    })
}
// 上传附件
export const uploadFiles = params => {
    return request({
        url: `${SRM}/supplierQualificationInfo/insertUpdate`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 上传附件
export const insertUpdateIdCard = params => {
    return request({
        url: `${SRM}/supplierQualificationInfo/insertUpdateIdCard`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 增加附件
export const addQualification = params => {
    return request({
        url: `${SRM}/supplierQualificationInfo/insertCustom`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 删除资质
export const delQualification = params => {
    return request({
        url: `${SRM}/supplierQualificationInfo/batchDelete`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 获取资质信息树状结构（管理端）
export const getManageTreeData = params => {
    return request({
        url: `${SRM}/supplierQualificationInfo/getManageTreeData`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 获取登录用户
export const getLoginUser = (params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/currentLoginUser/supplierCode`,
        method: 'get',
        params: params,
    })
}
// 下载模板
export const downloadRegisterGuide = params => {
    return request({
        url: `${PFX}/public/supplier/supplierInfo/downloadRegisterGuide`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
    })
}

// 供应商评分表-详情接口
export const onlineDetail = data => {
    return request({
        url: `${SRM}/supplierQualificationInfo/onlineDetail`,
        method: 'get',
        params: data,
    })
}

// 供应商评分表-确认提交
export const onlineSave = data => {
    return request({
        url: `${SRM}/supplierQualificationInfo/onlineSave`,
        method: 'post',
        data,
    })
}
